import SEO from "../components/SEO";
import "../styles/TermsOfService.css";

function TermsOfService() {
  return (
    <div className="terms-of-service-container">
      <SEO title="Terms of Service" description="MacroMatrix terms of service — rules and conditions for using our apps, games, and services." path="/termsofservices" />
      <p>
        <strong>Terms of Service</strong>
      </p>
      <p>
        These Terms of Service (the &ldquo;Terms&rdquo; or
        &ldquo;Agreement&rdquo;) are a legally binding agreement between our
        company and its Affiliates (collectively, &ldquo;MacroMatrix Private
        Limited&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;, or
        &ldquo;our&rdquo;) and you (&ldquo;You&rdquo; or &ldquo;Your&rdquo;)
        with respect to your use of or access to MacroMatrix Private
        Limited&rsquo;s mobile or web applications, games, websites, and/or any
        other services owned, operated, and published by MacroMatrix Private
        Limited (collectively, the &ldquo;Services&rdquo;). Affiliates shall
        mean subsidiaries, parent companies, joint ventures, and other
        organizations or entities under common ownership with our company.
      </p>
      <p>
        PLEASE REVIEW THESE TERMS CAREFULLY BEFORE USING THIS SERVICE. BY
        INSTALLING, USING, OR OTHERWISE ACCESSING ANY SERVICE, YOU AGREE TO AND
        ACCEPT THESE TERMS AND ACKNOWLEDGE THAT YOU READ, UNDERSTAND, AND AGREE
        TO BE LEGALLY BOUND BY THE TERMS. IF YOU DO NOT AGREE TO THESE TERMS,
        PLEASE EXIT SUCH SERVICE IMMEDIATELY AND DO NOT INSTALL, USE OR
        OTHERWISE ACCESS THE SERVICES. USE OF THE SERVICES IS VOID WHERE
        PROHIBITED.
      </p>
      <p>
        In addition to this Agreement, the MacroMatrix Private Limited privacy
        policy (the &ldquo;Privacy Policy&rdquo;) applies to your use of or
        access to the Services, and you should review it prior to any use of or
        access to the Services. Your use of or access to the Services is
        strictly subject to these Terms as may be updated from time to time.
      </p>
      <p>
        <strong>1: Change To The Terms And Services</strong>
      </p>
      <p>
        MacroMatrix Private Limited reserves the right, at its sole discretion,
        to change, modify the Terms, its Privacy Policy and other relevant
        MacroMatrix Private Limited policies, at any time and from time to time
        by posting the amended terms, policies or rules on the MacroMatrix
        Private Limited Services. You may be required to accept updates to the
        Services in order to continue use or access. You will be deemed to have
        accepted such changes and updates in their entirety and without
        reservation by continuing to use or access the Services. If at any point
        you do not agree to any portion of the then-current version of our
        Terms, the Privacy Policy, or any other MacroMatrix Private Limited
        policies, or other codes of conduct relating to your use of or access to
        the Services, your use of or access to the Services shall immediately
        terminate.
      </p>
      <p>
        <strong>2: Right To Use The Services</strong>
      </p>
      <p>
        Subject to your continuous compliance with the Terms, the Privacy
        Policy, or any other MacroMatrix Private Limited policies, or other
        codes of conduct, MacroMatrix Private Limited grants to you a
        non-exclusive, personal, worldwide, non-transferable, non-sub-licensable
        and revocable limited license to access and use the Services solely for
        your own non-commercial entertainment purposes by accessing the Services
        through a web browser or mobile device. You explicitly agree that you
        will not use the Services for any other purpose other than as provided
        for by these Terms. You agree not to copy, modify, create a derivative
        work of, reverse engineer, decompile or otherwise attempt to extract
        source code of the Services or to allow or assist anyone else to do so.
      </p>
      <p>
        MacroMatrix Private Limited expressly reserves the right to deny anyone
        access to the Services at any time for any reason with or without
        notice. You agree that MacroMatrix Private Limited may cease providing
        the Services or change the content of the Services at any time for any
        reason with or without notice to you without liability. YOU MUST BE
        THIRTEEN (13) YEARS OF AGE OR OLDER TO USE THE SERVICES. Additionally,
        if you are using or accessing the Services from a jurisdiction that
        requires a person to be older in order to participate legally in the
        Services, then you represent and undertake that you are of such legal
        age. MacroMatrix Private Limited reserves the right to request proof of
        age at any stage to verify that persons not of legal age are not using
        or accessing the Services. If you access the Services from a Social
        Networking Site (&ldquo;SNS&rdquo;), such as Facebook or Google+, then
        you acknowledge that you have also complied with, and will continue to
        remain in compliance with, the terms of service/use of such SNS as well
        as the Terms for the duration of your use of the Services.
      </p>
      <p>
        <strong>3: Account With MacroMatrix Private Limited</strong>
      </p>
      <p>
        You may be required to register and establish an account in order to use
        the Services. You agree to provide accurate and complete registration
        information, and you will be responsible for keeping your password
        confidential.
      </p>
      <p>
        Your account is unique to you, and you may neither transfer (or
        otherwise make available) your account to others, nor use anyone
        else&rsquo;s account at any time. If you distribute your account or
        related information, MacroMatrix Private Limited reserves all rights to
        terminate your account immediately and without refund.
      </p>
      <p>
        You shall not create an account using a false identity or information,
        or on behalf of someone other than yourself.
      </p>
      <p>
        You are responsible for maintaining the confidentiality of your account
        information (including usernames, passwords and billing information).
        MacroMatrix Private Limited is not liable for any loss that you may
        incur as a result of someone else using your account, whether or not
        that activity is authorized by you.
      </p>
      <p>
        You are liable for any losses or damages incurred by MacroMatrix Private
        Limited or any third party as a result of someone else using your
        account. In the event of theft, unauthorized use, or any other breach of
        security on your account, you must notify MacroMatrix Private Limited in
        writing immediately.
      </p>
      <p>
        You are responsible for any and all activities that occur under or in
        connection with your account created in order for you to use the
        Services.
      </p>
      <p>
        <strong>4: Intellectual Property/Ownership</strong>
      </p>
      <p>
        All materials that are part of the Services (including, but not limited
        to, games, applications, code, themes, maps, character, stories,
        concept, animation, artwork, effect, methods of operation, transcript,
        designs, text, graphics, pictures, video, information, applications,
        software, music, brand, sound and other files, and their selection and
        arrangement) are protected by law from unauthorized use. The entire
        contents of the Services are copyrighted under the applicable copyright
        laws and/or similar laws of other jurisdictions.
      </p>
      <p>
        You agree that no materials that are part of the Services may be
        modified, copied, distributed, framed, reproduced, republished,
        downloaded, scraped, displayed, posted, transmitted, or sold in any form
        or by any means, in whole or in part, or otherwise exploited without
        MacroMatrix Private Limited&rsquo;s express prior written permission,
        except that the foregoing does not apply to your own User Content (as
        defined below). All other uses of copyrighted material, including any
        derivative use, require express prior written permission from
        MacroMatrix Private Limited. Any reproduction or redistribution of
        materials not in accordance with these Terms is expressly prohibited and
        may result in severe civil and criminal penalties.
      </p>
      <p>
        MacroMatrix Private Limited and/or its licensors remain the owners of
        right, title, and interest, including copyrights and other intellectual
        property rights, in and to all materials posted on the Services by
        MacroMatrix Private Limited. You acknowledge that you do not acquire any
        ownership rights by using the Services or by accessing any materials
        posted on the Services by MacroMatrix Private Limited, or any derivative
        works thereof. All rights, title and interest in and to the Service
        (including without limitation any games, titles, computer code, themes,
        objects, characters, character names, stories, dialogue, catch phrases,
        concepts, artwork, animations, sounds, musical compositions,
        audio-visual effects, methods of operation, moral rights, documentation,
        in-game chat transcripts, character profile information, recordings of
        games played using a MacroMatrix Private Limited game client, and the
        MacroMatrix Private Limited game clients and server software) are owned
        by MacroMatrix Private Limited. MacroMatrix Private Limited reserves all
        rights, including without limitation, all intellectual property rights
        or other proprietary rights, in connection with its games and the
        Service.
      </p>
      <p>
        NOTWITHSTANDING ANYTHING TO THE CONTRARY HEREIN, YOU ACKNOWLEDGE AND
        AGREE THAT YOU SHALL HAVE NO OWNERSHIP OR OTHER PROPERTY INTEREST IN THE
        ACCOUNT, AND YOU FURTHER ACKNOWLEDGE AND AGREE THAT ALL RIGHTS IN AND TO
        THE ACCOUNT ARE AND SHALL FOREVER BE OWNED BY AND INURE TO THE BENEFIT
        OF MacroMatrix Private Limited OR ITS ASSIGNEES.[Please provide
        additional sections when ready.]
      </p>
      <p>
        <strong>5: User Content</strong>
      </p>
      <p>
        Any communications, comments, chats, sounds and images, and all the
        material, data, text, graphics, photographs and their selection and
        arrangement uploaded to the Services (&ldquo;User Content&rdquo;) are
        subject, whether in whole or in part, to unlimited commercial,
        worldwide, non-commercial and/or promotional use by MacroMatrix Private
        Limited.
      </p>
      <p>
        You hereby grant MacroMatrix Private Limited and its affiliates a
        perpetual and irrevocable, worldwide, fully paid-up and royalty free,
        non-exclusive, unrestricted, unconditional, unlimited license, including
        the right to sublicense, transfer and assign to third parties, and right
        to copy, print, host, reproduce, fix, adapt, modify, improve, retitle,
        translate, reformat, archive, store, cache or otherwise exploit in any
        manner, create derivative works from, manufacture, introduce into
        circulation, commercialize, publish, distribute, disclose, sell, resell,
        license, sublicense, transfer, rent, lease, transmit, publicly display,
        publicly perform, or provide access to electronically, broadcast,
        communicate to the public by telecommunication, display, perform, enter
        into computer memory, and use and practice, in any way now known or in
        the future discovered, in any media, at any time, your User Content as
        well as all modified and derivative works thereof in connection with our
        provision of the Service, including advertising, marketing and
        promotions thereof. No credit, approval or compensation is due to you
        for any such use or disclosure of the User Content you may submit. Any
        text, graphics, and photographs and other User Content uploaded by you
        shall be your sole responsibility. Thus, users are solely responsible,
        and MacroMatrix Private Limited is not responsible, for any User Content
        users upload, post, share, or otherwise make available. MacroMatrix
        Private Limited may or may not regulate User Content and does not
        guarantee the accuracy, quality, or integrity of any User Content on any
        of the Services. By using the Services, you acknowledge and accept that
        you may be exposed to material you find offensive or objectionable. You
        agree that MacroMatrix Private Limited will not under any circumstances
        be liable for any User Content, including, but not limited to, errors in
        any User Content, or any loss or damage incurred by use of the User
        Content. MacroMatrix Private Limited reserves the right to remove and
        permanently delete any User Content from the Services with or without
        notice for any reason.
      </p>
      <p>
        <strong>6: User Interactions</strong>
      </p>
      <p>
        You are solely responsible for your interactions with other users of the
        Services and any other parties with whom you interact through the
        Service and/or MacroMatrix Private Limited&rsquo;s games. MacroMatrix
        Private Limited reserves the right, but has no obligation, to become
        involved in any way with disputes between users. You will fully
        cooperate with MacroMatrix Private Limited to investigate any suspected
        unlawful, fraudulent or improper activity, including, without
        limitation, granting MacroMatrix Private Limited access to any
        password-protected portions of your Account.
      </p>
      <p>
        If you have a dispute with one or more users, you release us (and our
        officers, directors, agents, subsidiaries, joint ventures and employees)
        from claims, demands and damages (actual and consequential) of every
        kind and nature, known and unknown, arising out of or in any way
        connected with such disputes.
      </p>
      <p>
        <strong>7: Virtual Currencies/Goods</strong>
      </p>
      <p>
        The Services may include an opportunity to earn and purchase virtual,
        in-game currency, including but not limited to virtual coins, points,
        and credits (collectively, &ldquo;Virtual Currency&rdquo;) that may
        require you to pay a fee using lawful currency or &ldquo;real
        money&rdquo; to obtain the Virtual Currency. The Services may also
        include virtual, in-game digital items (collectively, &ldquo;Virtual
        Goods&rdquo;) that may be purchased from MacroMatrix Private Limited
        with &ldquo;real money&rdquo; or with Virtual Currency. Virtual Currency
        and Virtual Goods can never be redeemed for lawful currency, goods, or
        any other item of monetary value from MacroMatrix Private Limited or any
        other party. You acknowledge and agree that Virtual Goods or Virtual
        Currency are licensed to you for your use through the Services and are
        subject to applicable laws and rules, the Terms, and limitations and
        terms set out in each game.
      </p>
      <p>
        Your purchase of Virtual Currency and/or Virtual Goods is final and is
        not refundable, exchangeable, or transferable, unless required by law.
        You may not purchase, sell, or exchange Virtual Currency or Virtual
        Goods outside of the Services. These transfers are strictly prohibited,
        and we shall not be liable for any claims or damages suffered by the
        users with respect to Virtual Currency or Virtual Goods purchased or
        obtained from any third party. Doing so is a violation of the Terms and
        may result in termination of your account with the Services and/or legal
        action taken against you.
      </p>
      <p>
        MacroMatrix Private Limited retains the right to modify, manage, control
        and/or eliminate Virtual Currency and/or Virtual Goods at its sole
        discretion. Prices and availability of Virtual Goods and services are
        subject to change without notice.
      </p>
      <p>
        YOU ACKNOWLEDGE AND AGREE THAT MacroMatrix Private Limited IS NOT
        REQUIRED TO PROVIDE A REFUND FOR ANY REASON. IN THE EVENT OF A REFUND AS
        REQUIRED BY APPLICABLE LAWS, THE TERMS AND CONDITIONS OF THIRD-PARTY
        PAYMENT PROCESSOR WILL APPLY AND ANY RELATED FEES SHALL BE BORNE BY YOU;
        AND THAT YOU WILL NOT RECEIVE LAWFUL CURRENCY OR OTHER COMPENSATION FOR
        UNUSED VIRTUAL CURRENCY AND VIRTUAL GOODS WHEN AN ACCOUNT IS CLOSED,
        WHETHER SUCH CLOSURE WAS VOLUNTARY OR INVOLUNTARY.
      </p>
      <p>
        <strong>8: Updates to the Service</strong>
      </p>
      <p>
        You understand that each Service is an evolving one. MacroMatrix Private
        Limited may require that you accept updates to the Services and to
        MacroMatrix Private Limited&rsquo;s games that you may have installed on
        your device or computer. You acknowledge and agree that MacroMatrix
        Private Limited may update the Services and MacroMatrix Private
        Limited&rsquo;s games, with or without notifying you. You may need to
        update third party software from time to time in order to receive the
        Services and play MacroMatrix Private Limited&rsquo;s games.
      </p>
      <p>
        <strong>9: Rules of Conduct/Usage</strong>
      </p>
      <p>
        The Services may provide communication channels such as forums,
        communities, or chat areas (&ldquo;Communication Channels&rdquo;)
        designed to enable you to communicate with other users of the Services.
        MacroMatrix Private Limited has no obligation to monitor these
        Communication Channels, but MacroMatrix Private Limited may do so and
        reserves the right to review materials posted to the Communication
        Channels and to remove any materials, at any time, with or without
        notice for any reason, at our sole discretion. MacroMatrix Private
        Limited may also terminate or suspend your access to any Communication
        Channels at any time, without notice, for any reason. You acknowledge
        that chats, postings, or materials posted by users on the Communication
        Channels are neither endorsed nor controlled by MacroMatrix Private
        Limited, and these communications shall not be considered reviewed or
        approved by MacroMatrix Private Limited. MacroMatrix Private Limited
        will not under any circumstance be liable for any activity within
        Communication Channels.
      </p>
      <p>
        You agree that all your communications with the Communication Channels
        are public, and thus you have no expectation of privacy regarding your
        use of the Communication Channels. MacroMatrix Private Limited is not
        responsible for information that you choose to share on the
        Communication Channels, or for the actions of other users.
      </p>
      <p>
        You agree that your use of the Services shall be lawful at all times and
        that you will fully comply with the usage rules in all respects. In
        furtherance of the foregoing, and for illustrative purposes only and not
        as a limitation, you agree not to use the Services in order to: &bull;
        post, upload, transmit or otherwise disseminate information that is
        obscene, indecent, vulgar, pornographic, sexual or otherwise
        objectionable; &bull; defame, libel, ridicule, mock, stalk, threaten,
        harass, intimidate or abuse anyone, hatefully, racially, ethnically or,
        in a reasonable person&rsquo;s view, otherwise offensive or
        objectionable; &bull; upload or transmit (or attempt to upload or
        transmit) files that contain viruses, Trojan horses, worms, time bombs,
        cancelbots, corrupted files or data, or any other similar software or
        programs that may damage the operation of the Services or other
        users&rsquo; computers; &bull; violate the contractual, personal,
        intellectual property or other rights of any party including using,
        uploading, transmitting, distributing, or otherwise making available any
        information made available through the Services in any manner that
        infringes any copyright, trademark, patent, trade secret, or other right
        of any party (including rights of privacy or publicity); &bull; attempt
        to obtain passwords or other private information from other members;
        &bull; improperly use support channels or complaint buttons to make
        false reports to MacroMatrix Private Limited; &bull; develop,
        distribute, or publicly inform other members of &ldquo;auto&rdquo;
        software programs, &ldquo;macro&rdquo; software programs or other
        &ldquo;cheat utility&rdquo; software program or applications in
        violation of the applicable license agreements; &bull; exploit,
        distribute or publicly inform other members of any game error, miscue or
        bug which gives an unintended advantage; &bull; violate any applicable
        laws or regulations, or promote or encourage any illegal activity
        including, but not limited to, hacking, cracking or distribution of
        counterfeit software, or cheats or hacks for the Services.
      </p>
      <p>
        <strong>10. Privacy and Protection of Personal Information</strong>
      </p>
      <p>
        Information collected from you is subject to the pertinent SNS&rsquo;s
        policy. By using the Services, you may be granting your social network
        permission to share your e-mail address and any other personally
        identifiable information with MacroMatrix Private Limited. You also
        grant MacroMatrix Private Limited access to your friend lists upon the
        SNS to establish social connections in the Services. Please see our
        Privacy Policy for more information on the collection and use of your
        information. You acknowledge and agree that the Privacy Policy is
        incorporated and made part of these Terms.
      </p>
      <p>
        <strong>11. Disclaimer of Warranty</strong>
      </p>
      <p>
        YOU AGREE THAT YOUR USE OF AND ACCESS TO THE SERVICES SHALL BE AT YOUR
        SOLE RISK, AND THAT MacroMatrix Private Limited PROVIDES THE SERVICES ON
        AN &ldquo;AS IS&rdquo; BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW,
        MacroMatrix Private Limited, ITS AFFILIATES, OFFICERS, DIRECTORS,
        EMPLOYEES, AND AGENTS DISCLAIM ALL WARRANTIES, WHETHER EXPRESS OR
        IMPLIED (WHETHER BY LAW, STATUTE OR OTHERWISE), IN CONNECTION WITH THE
        WEBSITE AND YOUR USE THEREOF, INCLUDING BUT NOT LIMITED TO IMPLIED
        WARRANTIES OF TITLE, MERCHANTABILITY, SATISFACTORY QUALITY OR FITNESS
        FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY, AUTHORITY,
        COMPLETENESS, USEFULNESS, AND TIMELINESS OF THE SERVICES, OR
        INFRINGEMENT OF APPLICABLE LAWS AND REGULATIONS. THE ENTIRE RISK AS TO
        THE USE, QUALITY, AND PERFORMANCE OF THE SERVICES LIES WITH YOU.
      </p>
      <p>
        MacroMatrix Private Limited makes no warranties or representations about
        the accuracy of any information, the reliability of the materials, the
        full functionality of the Services, or the completeness of the content
        on the Services or any linked sites. MacroMatrix Private Limited does
        not warrant that the Services will meet your requirements, be
        uninterrupted, timely, secure, or error-free, that defects will be
        corrected, that the server hosting the Services is free of viruses or
        bugs, or that the systems or networks will be backed up. MacroMatrix
        Private Limited assumes no liability or responsibility for any (i)
        errors, mistakes, or inaccuracies of content, (ii) personal injury or
        property damage of any nature resulting from your use of the Services,
        (iii) any unauthorized access to our secure servers or the personal and
        financial information stored therein, (iv) any interruption or cessation
        of transmission to or from the Services, (v) any bugs, viruses, Trojan
        horses, or the like transmitted to or through the Services by any third
        party, or (vi) any errors or omissions in any content or any loss or
        damage of any kind incurred as a result of the use of any content
        posted, emailed, transmitted, or otherwise made available via the
        Services.
      </p>
      <p>
        MacroMatrix Private Limited shall not be liable for any acts or
        omissions made by your internet service provider or other third party
        with whom you have contracted to gain access to the server that hosts
        the MacroMatrix Private Limited sites.
      </p>
      <p>
        <strong>12. Limitation of Liability</strong>
      </p>
      <p>
        YOU ACKNOWLEDGE AND AGREE THAT:
        <br /> &bull; YOU ARE FREE TO CHOOSE WHETHER TO USE THE SERVICES AND DO
        SO AT YOUR SOLE OPTION, DISCRETION, AND RISK.
        <br /> &bull; MacroMatrix Private Limited DOES NOT GUARANTEE THAT YOU
        WILL BE ABLE TO ACCESS OR USE THE SERVICES AT ALL TIMES OR ALL
        LOCATIONS, OR THAT MacroMatrix Private Limited WILL HAVE ADEQUATE
        CAPACITY FOR THE SERVICES IN ANY SPECIFIC GEOGRAPHIC AREA.
      </p>
      <p>
        UNDER NO CIRCUMSTANCES WILL MacroMatrix Private Limited BE LIABLE TO YOU
        FOR MORE THAN THE AMOUNT YOU HAVE PAID TO MacroMatrix Private Limited IN
        THE NINETY (90) DAYS IMMEDIATELY PRECEDING THE DATE ON WHICH YOU FIRST
        ASSERT ANY CLAIM. TO THE FULLEST EXTENT PERMITTED BY LAW, NEITHER
        MacroMatrix Private Limited NOR ANY THIRD PARTY SERVICE PROVIDER OR
        THIRD PARTY LICENSOR SHALL BE LIABLE TO YOU OR ANY THIRD PARTY IN
        CONTRACT, TORT, NEGLIGENCE, OR OTHERWISE FOR ANY LOSS OR DAMAGE
        WHATSOEVER ARISING FROM OR IN ANY WAY CONNECTED WITH YOUR USE OR ANY
        THIRD PARTY&rsquo;S USE OF THE SERVICES, WHETHER DIRECT OR INDIRECT,
        INCLUDING, WITHOUT LIMITATION, ANY ACT OR FAILURE TO ACT REGARDING
        CONDUCT, COMMUNICATION, OR CONTENT ON THE SERVICES, OR USE OF ANY LINK
        CONTAINED ON THE SITE. THE DISCLAIMERS OF LIABILITY CONTAINED HEREIN
        APPLY TO ALL DAMAGES OR INJURY CAUSED BY OR RELATED TO THE USE OF, OR
        INABILITY TO USE, THE SERVICES UNDER ANY CAUSE OF ACTION OF ANY
        JURISDICTION.
      </p>
      <p>
        IN NO EVENT SHALL MacroMatrix Private Limited OR ANY THIRD PARTY SERVICE
        PROVIDER OR THIRD PARTY LICENSOR BE LIABLE TO YOU OR ANY THIRD PARTY
        BEYOND THE AMOUNT YOU HAVE PAID TO MacroMatrix Private Limited IN THE
        NINETY (90) DAYS FOR ANY INDIRECT, INCIDENTAL, PUNITIVE, SPECIAL,
        EXEMPLARY, OR OTHER PECUNIARY OR CONSEQUENTIAL LOSSES (INCLUDING,
        WITHOUT LIMITATION, LOSS OF BUSINESS, REVENUE, PROFITS, USE, DATA, OR
        OTHER ECONOMIC ADVANTAGE), HOWEVER CAUSED, WHETHER FOR BREACH OF
        CONTRACT OR IN TORT OR OTHERWISE, EVEN IF THEY HAVE BEEN INFORMED OF THE
        POSSIBILITY OF SUCH DAMAGE.
      </p>
      <p>
        MacroMatrix Private Limited SHALL NOT BE LIABLE, AND YOU AGREE NOT TO
        SEEK TO HOLD MacroMatrix Private Limited LIABLE, FOR THE CONDUCT OF
        THIRD PARTIES, INCLUDING OTHER USERS OF THE SERVICES, WITH THE ENTIRE
        RISK OF THE SERVICES, THIRD PARTY WEBSITES, AND ANY INJURY THEREFROM
        RESTING WITH YOU, INCLUDING ANY DAMAGE OR LOSS OF ANY KIND.
      </p>
      <p>
        <strong>13. Indemnification by You</strong>
      </p>
      <p>
        You agree to defend, fully indemnify, and hold MacroMatrix Private
        Limited, its third party service providers and licensors, and their
        respective officers, directors, agents, and employees (the
        &ldquo;Indemnified Parties&rdquo;) harmless from and against any and all
        claims, liabilities, losses, injuries, damages, costs, or expenses
        (including attorneys&rsquo; fees and costs) incurred by any Indemnified
        Party arising out of or resulting from your access or use of the
        Services, including (but not limited to) your breach or alleged breach
        of any term, condition, obligation, representation, or warranty
        contained in these Terms; any violation by you of any law or the rights
        of any third party; any User Content posted, transmitted, or provided by
        you or on your behalf; any use by you of the Services or use by any
        other person accessing the Services using your user identification
        (whether or not with your authorization); your violation of any third
        party&rsquo;s intellectual property or other legal rights; or the
        illegal or improper use of your user account.
      </p>
      <p>
        <strong>14. Limitations Period for Claims</strong>
      </p>
      <p>
        NOTWITHSTANDING ANY LAW TO THE CONTRARY, ANY CAUSE OF ACTION ARISING OUT
        OF OR RELATED TO YOUR ACCOUNT(S), USE OF THE SERVICES, THESE TERMS, THE
        PRIVACY POLICY, OR ANY RELATED MATTER MUST COMMENCE WITHIN ONE (1) YEAR
        AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS
        PERMANENTLY BARRED.
      </p>
      <p>
        <strong>15. Severability</strong>
      </p>
      <p>
        You and MacroMatrix Private Limited agree that if any portion of these
        Terms of Service or of the MacroMatrix Private Limited Privacy Policy is
        found to be illegal or unenforceable in whole or in part by any court or
        tribunal of competent jurisdiction, such provision shall, for that
        jurisdiction only, be ineffective solely to the extent of such
        determination without affecting the validity or enforceability of the
        remainder of the provision or any other provision, which shall continue
        in full force and effect.
      </p>
      <p>
        <strong>16. No Waiver</strong>
      </p>
      <p>
        The failure of MacroMatrix Private Limited to require or enforce strict
        performance by you of any provision of these Terms or the MacroMatrix
        Private Limited Privacy Policy, or its failure to exercise any right
        under them, shall not be construed as a waiver or relinquishment of
        MacroMatrix Private Limited&rsquo;s right to assert or rely upon any
        such provision or right in that or any other instance.
      </p>
      <p>
        The express waiver by MacroMatrix Private Limited of any provision,
        condition, or requirement of these Terms or the MacroMatrix Private
        Limited Privacy Policy shall not constitute a waiver of any of your
        future obligations to comply with such provision, condition, or
        requirement.
      </p>
      <p>
        Except as expressly and specifically set forth in these Terms, no
        representations, statements, consents, waivers, or other acts or
        omissions by MacroMatrix Private Limited shall be deemed a modification
        of these Terms or legally binding unless documented in physical writing
        and hand-signed by you and a duly appointed representative of
        MacroMatrix Private Limited.
      </p>
      <p>
        <strong>17. Notices</strong>
      </p>
      <p>
        We may notify you via postings on www.macromatrix.io, or via e-mail or
        any other means of communication. Except as specified in Section 20, all
        notices given by you or required from you under these Terms or the
        MacroMatrix Private Limited Privacy Policy must be in writing and sent
        to the following e-mail address: support@macromatrix.io. Notices
        provided without compliance with this Section 17 shall have no legal
        effect.
      </p>
      <p>
        <strong>18. Governing Laws</strong>
      </p>
      <p>
        For the purposes of these Terms, including Sections 19-21,
        &ldquo;Dispute&rdquo; means any dispute, claim, or controversy between
        you and MacroMatrix Private Limited arising out of these Terms or the
        MacroMatrix Private Limited Privacy Policy, arising out of your use of
        the Services, or regarding any aspect of your relationship with
        MacroMatrix Private Limited, whether such dispute, claim, or controversy
        is based in contract, statute, regulation, ordinance, tort (including,
        but not limited to, fraud, misrepresentation, fraudulent inducement, or
        negligence), or any other legal or equitable theory, and includes the
        validity, enforceability, or scope of these Terms, including
        specifically Section 20 (except for the enforceability of the Class
        Action Waiver clause below). &ldquo;Dispute&rdquo; shall include any
        Dispute brought by any individual purporting to act on your behalf or
        any individual or entity seeking damages, recovery, or relief for injury
        associated with or suffered by you. &ldquo;Dispute&rdquo; is to be given
        the broadest possible meaning that will be enforced.
      </p>
      <p>
        If you reside in the United States or assert a Dispute arising under or
        related to any U.S. law (including the laws of any State or subdivision
        thereof), this Agreement (including the Privacy Policy) and your
        relationship with MacroMatrix Private Limited, as well as any Dispute,
        shall be governed by and interpreted in accordance with the laws of
        California, without regard to any conflict of laws principles and
        regardless of your location. Otherwise, the relationship between the
        parties and any Dispute shall be governed by and interpreted in
        accordance with the laws of Singapore, without regard to principles of
        conflict of laws and regardless of your location.
      </p>
      <p>
        <strong>
          19. Dispute Resolution&mdash;If You Live in the United States
        </strong>
      </p>
      <p>
        PLEASE READ THIS DISPUTE RESOLUTION PROVISION (&ldquo;PROVISION&rdquo;)
        CAREFULLY BECAUSE IT AFFECTS YOUR RIGHTS. BY AGREEING TO BINDING
        ARBITRATION, YOU WAIVE YOUR RIGHT TO LITIGATE DISPUTES THROUGH A COURT
        AND TO HAVE A JUDGE OR JURY DECIDE YOUR CASE.
      </p>
      <p>
        If you live in the United States, you and MacroMatrix Private Limited
        agree that all disputes between you and MacroMatrix Private Limited will
        be settled by binding arbitration, unless otherwise provided herein.
      </p>
      <p>
        This agreement does not apply (1) if you are a resident of any
        jurisdiction which prohibits this arbitration agreement, (2) if you opt
        out of this arbitration agreement as described in Section (e) below, or
        (3) to certain types of disputes described in Section (e) below. Please
        read this Provision carefully.
      </p>
      <p>
        a. <strong>Purpose &amp; Disputes Covered</strong>
      </p>
      <p>
        This Provision facilitates the prompt and efficient resolution of any
        disputes (including, except as provided below, a dispute as to whether a
        dispute is covered by this arbitration agreement) that may arise between
        MacroMatrix Private Limited and you or anyone acting on your behalf,
        asserting your rights, or seeking damages or losses incurred by you.
      </p>
      <p>
        Arbitration is a form of private dispute resolution in which parties
        waive their rights to file a lawsuit, proceed in court, and have a judge
        or jury decide the case. In the absence of an arbitration agreement, you
        might otherwise have the right to bring claims in court, have them
        decided by a judge or jury, and/or participate in a case filed by others
        (including, but not limited to, class actions or representative
        actions). By agreeing to these Terms, you waive your right to litigate
        claims in court and to have your claims heard by a judge or jury. There
        is no judge or jury in arbitration, and court review of an arbitration
        award is limited. The arbitrator must follow this agreement and can
        award the same damages and relief as a court (including attorneys&rsquo;
        fees).
      </p>
      <p>
        When you first consent to these Terms, you have the right to opt out of
        this Provision, meaning you would retain your right to litigate your
        disputes in a court. If you have previously consented to arbitrate, then
        you may only opt out of the revised arbitration procedure contained
        herein, and the last Terms you agreed to will govern our relationship
        going forward.
      </p>
      <p>
        b.{" "}
        <strong>Agreement to Arbitrate / Waiver of Right to Jury Trial</strong>
      </p>
      <p>
        YOU AND MacroMatrix Private Limited EACH AGREE THAT, EXCEPT AS PROVIDED
        BELOW, ANY AND ALL DISPUTES, WHETHER PRESENTLY IN EXISTENCE OR BASED ON
        ACTS OR OMISSIONS IN THE PAST OR FUTURE, WILL BE RESOLVED EXCLUSIVELY
        AND FINALLY BY BINDING ARBITRATION RATHER THAN IN COURT IN ACCORDANCE
        WITH THIS PROVISION, AND YOU ARE WAIVING YOUR RIGHT TO A TRIAL BY JURY
        OR TO PARTICIPATE AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS ACTION,
        REPRESENTATIVE PROCEEDING, OR MASS OR COLLECTIVE ACTION (WHERE DAMAGES,
        LOSSES, OR INJURIES ASSOCIATED WITH YOU AND OTHER INDIVIDUALS OR
        ENTITIES ARE CONSIDERED IN A SINGLE ACTION). YOU AND MacroMatrix Private
        Limited AGREE THAT ANY DISPUTE OVER WHETHER A DISPUTE IS SUBJECT TO THIS
        PROVISION WILL BE RESOLVED BY BINDING ARBITRATION. Furthermore, any
        person purporting to act on your behalf, asserting your rights, or
        seeking damages or other remedies on your behalf will submit to binding
        arbitration as set forth herein.
      </p>
      <p>
        You understand and agree that by entering into this agreement, you and
        MacroMatrix Private Limited are each waiving the right to a jury trial
        or a trial before a judge in a public court. Except as otherwise
        provided, those rights are waived. Other rights that you would have if
        you went to court, such as the right to appeal and to certain types of
        discovery, may also be limited or waived.
      </p>
      <p>
        c. <strong>Class Action Waiver</strong>
      </p>
      <p>
        YOU AND MacroMatrix Private Limited AGREE THAT EACH MAY BRING CLAIMS IN
        ARBITRATION AGAINST THE OTHER ONLY IN AN INDIVIDUAL CAPACITY AND NOT ON
        A CLASS, MASS, COLLECTIVE, OR REPRESENTATIVE BASIS (&ldquo;CLASS ACTION
        WAIVER&rdquo;). YOU AND MacroMatrix Private Limited EACH AGREE TO WAIVE
        THE RIGHT TO PURSUE OR HAVE A DISPUTE RESOLVED AS A PLAINTIFF OR CLASS
        MEMBER IN ANY CLASS, COLLECTIVE, MASS, OR REPRESENTATIVE PROCEEDING.
      </p>
      <p>
        Except as otherwise provided in this Provision, the arbitrator shall
        have no authority to consolidate more than one person&rsquo;s claims or
        to preside over any form of a class or representative proceeding. The
        arbitrator may award declaratory or injunctive relief only in favor of
        the individual party seeking relief and only to the extent necessary for
        that party&rsquo;s individual claim(s).
      </p>
      <p>
        Notwithstanding any other provision, disputes regarding the
        interpretation, applicability, or enforceability of this Class Action
        Waiver shall be resolved only by a court and not by an arbitrator. In
        any case where: (1) the dispute is filed as a class, collective, or
        representative action, or falls within the scope of the Class Action
        Waiver, and (2) there is a final judicial determination that the Class
        Action Waiver is unenforceable with respect to any claim or remedy, then
        that claim or remedy (and only that claim or remedy) shall be severed
        and may be brought in a court of competent jurisdiction. All other
        claims or remedies shall be resolved in arbitration on an individual
        basis to the fullest extent possible.
      </p>
      <p>
        If you opt to pursue your dispute in court after opting out of this
        Provision (as described in Section (e) below), the Class Action Waiver
        will not apply to you. No user of the Services may serve as a class
        representative, class member, or otherwise participate in any class,
        consolidated, or representative proceeding without complying with the
        opt-out requirements below.
      </p>
      <p>
        d. <strong>Pre-Arbitration Claim Resolution</strong>
      </p>
      <p>
        Before initiating arbitration or litigation, you must first give
        MacroMatrix Private Limited the opportunity to resolve the dispute by
        contacting our customer support. Please send a written notification to:
      </p>
      <p>
        <strong>
          MacroMatrix Private Limited
          <br /> Office No 4-A-I Commercial Area, PGEHS, Lahore, Pakistan
          <br /> 7th Floor, Opal Tower, 701–705, BJK Blvd, Business Bay, Dubai – UAE
        </strong>
      </p>
      <p>This notice must include:</p>
      <ul>
        <li>Your name,</li>
        <li>Your address,</li>
        <li>A written description of your claim,</li>
        <li>Identification of the Service at issue,</li>
        <li>Your game account, and</li>
        <li>A description of the dispute and the specific relief you seek.</li>
      </ul>
      <p>
        If MacroMatrix Private Limited does not resolve the dispute within 45
        days after receiving your written notification, you may then pursue
        arbitration. You may pursue your dispute in court only under the
        circumstances described in Section (e) below.
      </p>
      <p>
        e. <strong>Exclusions from Arbitration/Right to Opt Out</strong>
      </p>
      <p>
        Notwithstanding the foregoing, you or MacroMatrix Private Limited may
        choose to pursue a dispute in court if:
        <br /> (i) the dispute qualifies to be initiated in small claims court;
        or
        <br /> (ii) you provide MacroMatrix Private Limited with a written
        notice of your desire to opt out of these arbitration procedures (the
        &ldquo;Arbitration Opt-Out Notice&rdquo;) within 30 days from the date
        you first consent to this Agreement.
      </p>
      <p>To opt out, you must send a written notice to:</p>
      <p>
        <strong>Office No 4-A-I Commercial Area, PGEHS, Lahore, Pakistan<br />7th Floor, Opal Tower, 701–705, BJK Blvd, Business Bay, Dubai – UAE</strong>
      </p>
      <p>The notice must include:</p>
      <ul>
        <li>Your name,</li>
        <li>Your address,</li>
        <li>Your game account, and</li>
        <li>
          A clear statement that you do not wish to resolve disputes with
          MacroMatrix Private Limited through arbitration.
        </li>
      </ul>
      <p>
        If you do not opt out within 30 days, you will be deemed to have waived
        your right to litigate disputes except as provided above.
      </p>
      <p>
        Nothing in this Provision precludes either party from seeking
        provisional remedies (such as injunctive relief) in aid of arbitration
        from a court of appropriate jurisdiction.
      </p>
      <p>
        f. <strong>Arbitration Procedures</strong>
      </p>
      <p>
        If this Provision applies and the dispute is not resolved as provided
        above, either you or MacroMatrix Private Limited may initiate
        arbitration proceedings. The parties may agree on a single arbitrator;
        otherwise, arbitration will be administered by ADR Services, Inc.
        (www.adrservices.com, (415) 772-0900) and conducted before a single
        arbitrator. Arbitration shall be conducted on an individual basis.
        Unless both parties agree otherwise in writing, the arbitrator shall
        have no authority to consolidate claims or preside over any class or
        representative proceeding. Except as provided in Section 20(c) above,
        all issues shall be determined by the arbitrator, including the scope
        and enforceability of this arbitration agreement and any related
        dispute, including any claim that all or part of this agreement is void
        or voidable. However, a court has exclusive authority to enforce the
        Class Action Waiver, as set forth above.
      </p>
      <p>
        ADR Services, Inc.&rsquo;s Arbitration Rules shall apply, except where
        they conflict with this Provision. Under no circumstances will class
        action procedures apply to the arbitration. Because the Services and
        these Terms concern interstate commerce, the Federal Arbitration Act
        (&ldquo;FAA&rdquo;) governs the arbitrability of all disputes.
      </p>
      <p>
        The arbitrator may award any relief available under applicable law on an
        individual basis and will not have the power to award relief to,
        against, or for the benefit of any non-party. The arbitrator&rsquo;s
        award shall be in writing and final, subject only to any review provided
        by the FAA, and may be entered in any court of competent jurisdiction
        for enforcement.
      </p>
      <p>
        g. <strong>Severability</strong>
      </p>
      <p>
        Notwithstanding Section 16 of these Terms, if any clause within this
        Provision (other than the Class Action Waiver clause) is found to be
        illegal or unenforceable, that clause will be severed from this
        Provision, and the remainder will continue in full force and effect.
        However, if the Class Action Waiver clause is found unenforceable, this
        entire Provision will be unenforceable and the dispute will be decided
        by a court.
      </p>
      <p>
        h. <strong>Continuation</strong>
      </p>
      <p>
        This Provision shall survive the termination of your account and/or your
        access to or use of the Services.
      </p>
      <p>
        <strong>
          20. Dispute Resolution&mdash;If You Live in a Country Other Than the
          United States
        </strong>
      </p>
      <p>
        PLEASE READ THIS SECTION CAREFULLY BECAUSE IT AFFECTS YOUR RIGHTS. BY
        AGREEING TO BINDING ARBITRATION, YOU WAIVE YOUR RIGHT TO LITIGATE
        DISPUTES THROUGH A COURT AND TO HAVE A JUDGE OR JURY DECIDE YOUR CASE.
      </p>
      <p>
        If a dispute arises between you and MacroMatrix Private Limited, we
        encourage you to first contact us directly to seek a resolution by
        visiting our customer support site at https://macromatrix.io/contact or
        by sending an email to support@macromatrix.io.
      </p>
      <p>
        Any dispute that arises in whole or in part from your use of or access
        to the Services shall be referred to and finally resolved by arbitration
        administered by the Singapore International Arbitration Center
        (&ldquo;SIAC&rdquo;) in accordance with the SIAC Arbitration Rules then
        in force. The seat of arbitration shall be Singapore, and the
        arbitration tribunal shall consist of one arbitrator. The language of
        the arbitration shall be English.
      </p>
      <p>
        YOU ACKNOWLEDGE AND AGREE THAT ANY PROCEEDINGS TO RESOLVE ANY DISPUTE
        SHALL BE CONDUCTED SOLELY ON AN INDIVIDUAL BASIS. NEITHER YOU NOR
        MacroMatrix Private Limited SHALL SEEK TO HAVE ANY DISPUTE HEARD AS A
        CLASS ACTION OR IN ANY REPRESENTATIVE PROCEEDING.
      </p>
      <p>
        <strong>21. Litigation, Jurisdiction, and Venue</strong>
      </p>
      <p>
        If you reside in the United States or initiate a dispute arising under
        or related to U.S. law (including the laws of any State or subdivision
        thereof), you and MacroMatrix Private Limited agree that:
        <br /> (i) any litigation between you and MacroMatrix Private Limited,
        including disputes relating to arbitration, shall be conducted
        exclusively in the courts located in San Francisco, California, and
        <br /> (ii) you consent to the personal jurisdiction of the state and
        federal courts located in San Francisco, California, for the purposes of
        any such litigation.
      </p>
      <p>
        <strong>22. General</strong>
      </p>
      <p>
        These Terms of Service, together with any supplemental policies and
        documents expressly incorporated by reference herein (including the
        MacroMatrix Private Limited Privacy Policy), constitute the entire
        agreement between you and MacroMatrix Private Limited and supersede all
        prior understandings regarding the subject matter herein, whether
        electronic, oral, or written.
      </p>
      <p>
        MacroMatrix Private Limited reserves the right to assign, transfer,
        sublicense, pledge, or delegate these Terms and the Privacy Policy, in
        whole or in part, to any person or entity at any time, with or without
        your consent. You may not assign, transfer, sublicense, pledge, or
        delegate any of your rights or obligations under these Terms without
        MacroMatrix Private Limited&rsquo;s prior written consent. MacroMatrix
        Private Limited may, in its sole discretion, terminate your account if
        any purported assignment by you is made.
      </p>
      <p>
        MacroMatrix Private Limited shall not be liable for any delay or failure
        to perform due to causes beyond its reasonable control, including acts
        of God, war, terrorism, riots, embargoes, acts of civil or military
        authorities, fire, floods, accidents, strikes, or shortages of
        transportation, fuel, energy, labor, or materials.
      </p>
      <p>
        Nothing in these Terms shall create or confer any rights or benefits to
        third parties. Nothing in these Terms shall be construed as creating an
        agency, partnership, trust arrangement, fiduciary relationship, or any
        other form of joint enterprise between you and MacroMatrix Private
        Limited.
      </p>
      <p>
        Nothing in these Terms grants you any security interest over the assets
        of MacroMatrix Private Limited, including any amounts credited to your
        account.
      </p>
      <p>
        By using the Services, you agree to comply with all applicable tax laws
        and release MacroMatrix Private Limited from any liability related to
        your compliance with such laws.
      </p>
      <p>
        This Agreement has been drafted in the English language. In the event of
        any discrepancy between any translated version and the English language
        version, the English version shall prevail.
      </p>
    </div>
  );
}

export default TermsOfService;
